<template>
    <component v-if="layoutVersion!==null" :is="layoutVersion" @onLayoutChange="onLayoutChange">
        <template v-slot:topNavBrand>
            <slot name="topNavBrand"></slot>
        </template>
        <template v-slot:topNavRight>
            <slot name="topNavRight"></slot>
        </template>
        <template v-slot:topNavMenus>
            <slot name="topNavMenus"></slot>
        </template>

        <template v-slot:sideMenu>
            <slot name="sideMenu"></slot>
        </template>

        <template v-slot:topBody>
            <slot name="topBody"></slot>
        </template>

        <template v-slot:leftBody>
            <slot name="leftBody"></slot>
        </template>
        <template v-slot:body>
            <slot name="body"></slot>
        </template>
        <template v-slot:bottomNavCenter>  
            <slot name="bottomNavCenter"></slot>
        </template>
        <template v-slot:footer>
            <slot name="footer"></slot>
        </template>
    </component>
</template>

<script>
    import LayoutVersion1 from './LayoutV1.vue';
    import LayoutVersion2 from './LayoutV2.vue';
    import LayoutVersion3 from './LayoutV3.vue';
    import ModalRelative from '../base/ModalRelative.vue';

    export default {
        components: {
            ModalRelative: ModalRelative,
            LayoutVersion1: LayoutVersion1,
            LayoutVersion2: LayoutVersion2,
            LayoutVersion3: LayoutVersion3
        },
        props: {

        },
        computed: {
            layoutInfo: function () {
                return this.$store.getters.configs.layout;
            }
        },
        data: function () {
            return {
                layoutVersion: null
            }
        },
        methods: {
            onLayoutChange: function (e) {
                console.log("Layout LayoutChange fire",e);
                this.$emit("onLayoutChange", e);
            }
        },
        created: function () {
            var layoutName = "LayoutVersion2";
            if (this.layoutInfo !== null) {
                layoutName = this.layoutInfo.layoutName
            }
            this.layoutVersion = layoutName;
        },
        destroyed: function () {

        },
        watch: {
        }
    }
</script>
